module.exports = __webpack_public_path__ + "img/intro-2-hover.c1bf0554.png";